module.exports = __webpack_public_path__ + "static/media/cross.bf4eee9d.png";